import {ModelRow, StringUtil} from "@mcleod/core";
import { SecondaryFilterProps } from "@mcleod/dispatch";

export class OrderPayablesTaskFilter {
    static readonly SUMMARY_PROCESS: SecondaryFilterProps = {
        id: "summaryProcess",
        caption: "In Summary Process",
        filter: (row: ModelRow) => {
            return row.get("process_status") == "S";
        }
    }

    static readonly PAYMENT_PROCESS: SecondaryFilterProps = {
        id: "paymentProcess",
        caption: "In Payment Process",
        filter: (row: ModelRow) => {
            return row.get("process_status") == "C";
        }
    }

    static readonly TP_EXCEPTION: SecondaryFilterProps = {
        id: "exception",
        caption: "Triumph Exceptions",
        filter: (row: ModelRow) => !StringUtil.isEmptyString(row.get("submittal_exception", "")),

    }

    static readonly TP_READY_TO_SUBMIT: SecondaryFilterProps = {
        id: "readyToSubmit",
        caption: "Triumph Ready to Submit",
        filter: (row: ModelRow) => row.get("ready_to_submit"),
    }

    static readonly TP_SUBMITTED: SecondaryFilterProps = {
        id: "submittedToTriumphPay",
        caption: "Triumph Submitted",
        filter: (row: ModelRow) => row.get("triumphpay_submitted")
    }

    static readonly TP_PAID: SecondaryFilterProps = {
        id: "paid",
        caption: "Triumph Paid",
        filter: (row: ModelRow) => row.get("paid")
    }
}
